import React from 'react';
import { NButton, NIcon } from '@innersource-nn/novoui-react';
import successIcon from 'assets/icons/blue/success.svg';
import clsx from 'clsx';

type LastStepType = 'error' | 'success' | 'info';
interface LastStepProps {
    title: string;
    description: React.JSX.Element;
    primaryButtonAction: () => void;
    handleCancel: VoidFunction;
    secondaryButtonAction?: VoidFunction;
    secondaryButtonText: string;
    primaryButtonText: string;
    type: LastStepType;
}

export default function LastStep({
    title,
    description,
    primaryButtonAction,
    handleCancel,
    secondaryButtonAction,
    primaryButtonText,
    secondaryButtonText,
    type,
}: LastStepProps) {
    const onClickSecondaryButton = () => {
        if (secondaryButtonAction) secondaryButtonAction();
        handleCancel();
    };

    return (
        <div>
            <div className="grid gap-16 p-5 justify-items-center text-center font-light">
                <div
                    className={clsx(
                        type === 'error'
                            ? 'bg-lava-red-200'
                            : type === 'info'
                              ? 'bg-sea-blue-200'
                              : 'bg-forest-green-200',
                        'round-div-icon-middle h-36 w-36',
                    )}
                >
                    {type === 'success' ? (
                        <img src={successIcon} alt="success-icon" />
                    ) : (
                        <NIcon
                            iconName={
                                type === 'error' ? 'alert' : 'information'
                            }
                            size={80}
                            className="fill-true-blue"
                        />
                    )}
                </div>
                <h2 className="mt-8 text-5xl font-bold text-true-blue">
                    {title}
                </h2>
                <p className="text-true-blue">{description}</p>
                <NButton
                    className="w-full bg-sea-blue-600 font-light"
                    square
                    onClick={primaryButtonAction}
                >
                    {primaryButtonText}
                </NButton>
                <NButton
                    className="w-full"
                    variant="outline"
                    square
                    onClick={onClickSecondaryButton}
                >
                    {secondaryButtonText}
                </NButton>
            </div>
        </div>
    );
}
